import { useQuery } from "@tanstack/react-query";
import { getAgentProfile } from "@/services/v2/agentProfile";

export const useAgentPublicProfile = (slug) =>
  useQuery({
    queryKey: ["agentPublicProfile", slug],
    queryFn: async () => {
      const response = await getAgentProfile(slug);
      return response?.result?.data || null;
    },
    enabled: Boolean(slug),
  });
